import React, { Component, Fragment, useEffect, useState } from 'react'
import { includes, map, orderBy } from 'libraries/lodash'
import Fuse from 'fuse.js'
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import cx from 'classnames'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import { COMPARISON_PROPS_LIMIT } from 'constants/mw-comparison-limits'
import ConfirmModal from 'components/shared/ConfirmModal'
import { replaceUrl } from 'front-end-core/core/history'
import { MW_DEAL_COMPARE } from 'constants/controllers'
import url from 'front-end-core/core/url'
import Checkbox from 'components/dealwatch/Checkbox'
import FilterListContainer from 'redux/containers/pages/mwdealcompare/FilterListContainer'

export default class FilterPanel extends Component {
  state = {
    search: '',
    showAll: true
  }

  $search = new Subject()
  subscription = null

  static getDerivedStateFromProps (nextProps, prevState) {
    if (nextProps.value !== prevState.value && nextProps.value.length === 0) {
      return { showAll: true }
    }
    return null
  }

  componentDidMount () {
    this.subscription = this.$search.pipe(
      debounceTime(500)
    ).subscribe(search => this.setState({ search }))
  }

  componentWillUnmount () {
    this.subscription.unsubscribe()
  }

  get selectedValuesLength () {
    return this.selectedValues.filter(x => !!x).length
  }

  get selectedValues () {
    return this.props.compareParams
  }

  get options () {
    const { comparableParams, compareParams } = this.props
    const sortedParams = orderBy(comparableParams, ['description', 'name'])
    const parameters = map(sortedParams, ({ name: value, description: label }) => ({
      label,
      value
    }))

    const opts = map(parameters || [], ({ label, value }, key) => ({
      key,
      label,
      value,
      checked: includes(compareParams, value),
      onClick: this.onOptionClick(value)
    }))

    if (!this.state.search) {
      return this.state.showAll
        ? opts
        : compareParams.filter(x => !!x).length
          ? opts.filter(o => o.checked)
          : opts.slice(0, 10)
    }

    const fuse = new Fuse(opts, {
      shouldSort: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['label', 'value']
    })
    return fuse.search(this.state.search)
  }

  handleInputChange = value => {
    this.$search.next(value)
  }

  onOptionClick = parameter => e => {
    this.validateChange(parameter, () => {
      const { short, aol } = this.props
      const value = this.selectedValues
      const show = value.includes(parameter)
        ? value.filter(currentParameters => currentParameters !== parameter)
        : [...value, parameter]
      const route = url(MW_DEAL_COMPARE, { aol, short }, { show })
      replaceUrl(route)
    })
  }

  handleResetFilterValue = () => {
    const { short, aol } = this.props
    replaceUrl(url(MW_DEAL_COMPARE, { aol, short }))
    this.setState({ showAll: true })
  }

  handleExpandAll = showAll => e => {
    this.setState({ showAll, search: '' })
  }

  validateChange = (parameter, callback) => {
    const removing = this.selectedValues.includes(parameter)
    if (!removing && (this.selectedValuesLength + 1) > COMPARISON_PROPS_LIMIT) {
      this.props.pageToggleOverlay(
        <ConfirmModal
          message={`You can only select up to ${COMPARISON_PROPS_LIMIT} parameters.`}
          cancelText='Ok'
          confirmText={null}
        />
      )
    } else {
      callback()
    }
  }

  render () {
    const { label, showReset = false } = this.props

    return (
      <div className='mb6'>
        <div className='flex justify-between black bb pb1'>
          <span className='black'>{label}</span>
          {showReset && this.selectedValuesLength > 0 && (
            <a
              href={null}
              onClick={this.handleResetFilterValue}
              className='pointer hover-underline cadet-blue f7'
            >
              <i>reset</i>
            </a>
          )}
        </div>
        <div className='relative mt2'>
          <Input value={this.state.search} onChange={this.handleInputChange} />
          <FilterListContainer>
            {this.options.map(({ checked, key, label, onClick }) => (
              <Fragment key={key}>
                <Checkbox {...{ label, onClick, checked }} />
              </Fragment>
            ))}
          </FilterListContainer>
          <div className='w-100 mt2'>
            <Expander
              expanded={this.state.search ? false : this.state.showAll}
              onChange={this.handleExpandAll}
              selectedValuesLength={this.selectedValuesLength}
              value={this.selectedValues}
            />
          </div>
        </div>
      </div>
    )
  }
}

const Input = (props) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(props.value)
  }, [props.value, setValue])

  const handleOnChange = e => {
    setValue(e.target.value)
    props.onChange(e.target.value)
  }

  return (
    <div className='flex justify-end placeholder-cadet-blue-important w-100 black'>
      <input
        placeholder='Search'
        className='pv2 ph3 w-100 bg-transparent ba mv2 mh0'
        type='text'
        value={value}
        onChange={handleOnChange}
      />
    </div>
  )
}

const Expander = ({ expanded, value, onChange, selectedValuesLength }) => {
  const disabled = expanded && !value[0]

  return !disabled && (
    <div
      className={cx(
        'tc black flex justify-center cadet-blue f7',
        { 'hover-underline': !disabled }
      )}
    >
      <a
        href={null}
        onClick={onChange(!expanded)}
        className={cx(
          'flex items-center pointer',
          { 'no-pointer-events grey': disabled }
        )}
      >
        <span>{expanded ? `Show ${selectedValuesLength} selected` : 'Show all'}</span>
        {!expanded && <ArrowDropDownIcon htmlColor='black' />}
        {expanded && <ArrowDropUpIcon htmlColor='black' />}
      </a>
    </div>
  )
}
